<template>
  <div class="main-content">
    <second-nav-bar></second-nav-bar>
    <div class="content">
      <div class="header">
        <span>运营 / 机构管理</span>
      </div>
      <div class="table-container scroll">
        <el-row>
          <el-col :span="24">
            <el-button
              type="primary"
              size="medium"
              @click="handleAdd"
              :disabled="isCity || $regional.disableCRUD"
              >添加机构</el-button
            >
          </el-col>
        </el-row>
        <el-row class="table">
          <el-col :span="24">
            <el-table :data="departmentData" size="medium">
              <el-table-column prop="name" label="机构名称"></el-table-column>
              <el-table-column
                prop="creditCode"
                label="信用代码"
              ></el-table-column>
              <el-table-column label="行政级别">
                <template slot-scope="scope">
                  <span>{{
                    scope.row.level === 1 ? '市级' : '区（县）级'
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="region.name"
                label="所属地区"
              ></el-table-column>
              <el-table-column
                prop="adminAccount"
                label="管理账号"
              ></el-table-column>
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    :disabled="isCity || $regional.disableCRUD"
                    @click="handleEdit(scope.$index, scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    :disabled="isCity || $regional.disableCRUD"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>

    <department-edit-box
      :visible.sync="editorVisible"
      :identify="departmentInfo"
      @edit-result="initDepartment"
    ></department-edit-box>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import SecondNavBar from '@/components/common/SecondNavBar'
import DepartmentEditor from '@/components/admin/operate/DepartmentEditor'
export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar,
    'department-edit-box': DepartmentEditor
  },

  data() {
    return {
      departmentData: [],
      editorVisible: false,
      departmentInfo: {}
    }
  },

  watch: {},

  computed: {
    ...mapState(['user']),
    isCity() {
      return this.user.level === 1
    },
    cityLevel() {
      return _.filter(this.departmentData, { level: 1 })
    }
  },

  mounted() {
    this.initDepartment()
  },

  methods: {
    initDepartment() {
      this.$xhrGet(`/acc/institutions`, { isSelf: false }).then(rs => {
        this.departmentData = rs.data
      })
    },

    handleAdd() {
      this.editorVisible = true
      this.departmentInfo = {}
      this.departmentInfo.cityLevel = this.cityLevel
    },

    handleEdit(index, row) {
      this.editorVisible = true
      this.departmentInfo = row
    },

    handleDelete(index, row) {
      if (!row.removable) {
        this.$message.error('该机构下存在归属学校或用户，无法删除')
        return false
      }
      this.$xhrDelete(`/acc/institutions/${row.id}`).then(rs => {
        if (rs.code === 'SUCCESS') {
          this.$message.success('操作成功')
          this.initDepartment()
        } else if (rs.code === 403) {
          // this.$message.success('')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  height: 100%;
  background: var(--theme-background);
}
.content {
  float: right;
  height: 100%;
  width: calc(100% - 200px);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  font-size: 14px;
  color: #757575;
  margin-left: 20px;
}
.table-container {
  width: calc(100% - 80px);
  max-height: calc(100% - 128px);
  overflow: auto;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.table {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/operate/DepartmentManage.vue